import { render, staticRenderFns } from "./SwaggerUI.vue?vue&type=template&id=1aa9250d&scoped=true"
import script from "./SwaggerUI.vue?vue&type=script&lang=js"
export * from "./SwaggerUI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa9250d",
  null
  
)

export default component.exports